import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withApi, customTypes } from 'utils';
import { datadogLogs } from '@datadog/browser-logs';

import { Typography, Spinner } from 'components/alf-design';

const EmailVerificationAlert = ({ params, api }) => {
  const [sending, setSending] = useState(false);
  const [showError, setShowError] = useState(false);
  const [sendError, setSendError] = useState('');

  const handleResend = async (e) => {
    e.preventDefault();
    const { email } = params;
    setSending(true);

    try {
      await api.resendVerificationEmail(email);
    } catch (error) {
      let description;
      if (error.response) {
        description = error.response.data.error;
      } else if (error.request) {
        description =
          'Network error. Please check your connection and try again.';
      } else {
        description =
          'There was an error sending the verification email. Please try again later.';
      }
      setSendError(description);

      datadogLogs.logger.error(`Email Verification - ${email}`, {
        error,
      });
    }

    setSending(false);
    setShowError(true);
  };

  return params.error && !showError ? (
    <div className="w-full bg-legacy-errorBackground m-[24px] p-[10px] rounded-[8px]">
      <Typography type="error" style={{ textAlign: 'center' }}>
        {params.error_description}
      </Typography>
      <div className="flex flex-col items-center">
        {sending ? (
          <div className="mt-[12px]">
            <Spinner color="legacy-error" />
          </div>
        ) : (
          <div
            onClick={handleResend}
            onKeyPress={handleResend}
            className="underline text-center max-w-max cursor-pointer mt-[12px]"
            role="link"
            tabIndex={0}
          >
            <Typography type="error" component="span" className="underline">
              Resend verification email
            </Typography>
          </div>
        )}
      </div>
    </div>
  ) : (
    <div className="bg-legacy-errorBackground m-[24px] p-[10px] rounded-[8px]">
      <Typography type="error" style={{ textAlign: 'center' }}>
        {sendError === '' ? 'Verification email has been sent.' : sendError}
      </Typography>
      <div className="flex flex-col items-center">
        {sending ? (
          <div className="mt-[12px]">
            <Spinner />
          </div>
        ) : (
          <div
            onClick={handleResend}
            onKeyPress={handleResend}
            className="underline text-center max-w-max cursor-pointer mt-[12px]"
            role="link"
            tabIndex={0}
          >
            <Typography type="error" component="span" className="underline">
              Resend verification email
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

EmailVerificationAlert.propTypes = {
  params: PropTypes.shape({
    error: PropTypes.string,
    error_description: PropTypes.string,
    email: PropTypes.string,
  }),
  api: customTypes.api,
};

export default withApi(EmailVerificationAlert);
